import styled from "styled-components";
import { BaseFlex, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { colorsPalettes } from "@similarweb/styles";
import { setFontVariant } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { NavBarIcon } from "@similarweb/ui-components";
export const StepCloseWrapper = styled(FlexRow)`
    box-sizing: border-box;
    padding-left: 2px;
    padding-right: 12px;
    height: 48px;
    border: 1px solid #e6e9ec;
    border-radius: 6px;
    background-color: rgba(245, 248, 255);
    justify-content: space-between;
    width: 100%;
    align-items: center;
    transition: all ease-in 0.3s;
    ${setFontVariant("input2", colorsPalettes.carbon[300])};
    &:hover {
        background-color: ${colorsPalettes.carbon[0]};
        color: ${colorsPalettes.carbon[500]};
        box-shadow: 0 3px 6px rgba(14, 30, 62, 0.08);
    }
`;
export const Title = styled(BaseFlex)``;

export const BodyStep = styled(FlexRow)`
    align-items: center;
`;

export const IconStep = styled.div`
    top: 12px;
    position: relative;
    margin-right: 10px;
`;
export const SkipText = styled.div`
    margin-left: 4px;
    ${setFontVariant("input2", colorsPalettes.carbon[200])};
`;

export const ButtonStyle = styled(Button)<{ isHoverStep: boolean }>`
    opacity: ${({ isHoverStep }) => (isHoverStep ? 1 : 0.5)};
`;
export const IconIsAllSkipped = styled(NavBarIcon)`
    margin-left: 16px;
    margin-right: 24px;
    width: 24px;
    height: 24px;
    text-align: center;
    border-radius: 50%;
    background-color: ${colorsPalettes.carbon[100]};
    ${setFontVariant("button", colorsPalettes.carbon[0])}
`;
